import * as analytics from './analytics.actions';
import * as session from '../session';
import * as invite from '../invite';
import * as router from '../router';
import { selectors as current } from '../current';
import { matchers } from '../http-request';

export function AnalyticsEpic() {
  return (action, { dispatch, getState }) => {
    if (session.matchers.isSignUpSuccess(action)) {
      const payload = getUserIdentifyPayload(getState());
      dispatch(analytics.alias(payload.id));
      dispatch(analytics.identify(payload));
    } else if (
      session.matchers.isCreateSuccess(action) ||
      session.matchers.isReadSuccess(action)
    ) {
      dispatch(analytics.identify(getUserIdentifyPayload(getState())));
    } else if (invite.matchers.isReadSuccess(action)) {
      dispatch(analytics.identify(getInviteIdentifyPayload(getState())));
    } else if (
      session.matchers.isDestroySuccess(action) ||
      session.matchers.isDestroyError(action) ||
      session.matchers.isReadError(action) ||
      matchers.isRequestResponseStatus.unauthorized(action)
    ) {
      dispatch(analytics.reset());
    }
  };
}

function getResourceIdentifyPayload(resource, state) {
  return {
    id: resource.uuid(state),
    traits: {
      firstName: resource.firstName(state),
      lastName: resource.lastName(state),
      email: resource.email(state),
      phone: formatPhoneNumber(
        resource.cellPhone(state) || resource.homePhone(state)
      ),
    },
  };
}

function formatPhoneNumber(phone) {
  return phone ? `+1${phone}` : null;
}

function getInviteIdentifyPayload(state) {
  // Get the token from the path (can't use the router selectors since
  // the params are not set yet)
  const token = location.pathname.split('/').pop();
  return getResourceIdentifyPayload(invite.selectors.byToken(token), state);
}

function getUserIdentifyPayload(state) {
  return getResourceIdentifyPayload(current.user(state), state);
}
